// Fase 1A — Servicio de IA (thin wrapper de axios). SOLO encapsula la llamada HTTP.
// La captura de imagen/voz y el procesamiento del resultado permanecen en el contenedor.
import api from "@/lib/api";

// POST /operativa/valet/ai-parse. `payload` (modo imagen/texto, imagen_base64, etc.) y `config`
// (p.ej. { timeout: 90000 }) se pasan sin modificación.
export const aiParse = (payload, config) =>
  api.post("/operativa/valet/ai-parse", payload, config);
